import React from 'react';
import { Box } from '@mui/material';
import ZoneList from '../../components/ZoneManagement/ZoneList';

const ZoneManagement = () => {
  return (
    <Box>
      <ZoneList />
    </Box>
  );
};

export default ZoneManagement; 